import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './TechStack.css';

import ReactIcon from '../Images/Icon/React.png';
import AngularIcon from '../Images/Icon/Angular.png';
import VueIcon from '../Images/Icon/vue.png';
import FlutterIcon from '../Images/Icon/flutter.png';
import EmberIcon from '../Images/Icon/express.png';
import BootstrapIcon from '../Images/Icon/bootstrap.png';

import NodeIcon from '../Images/Icon/node.png';
import ExpressIcon from '../Images/Icon/express.png';
import GoIcon from '../Images/Icon/Go.png';
import JavaIcon from '../Images/Icon/java.png';
import PythonIcon from '../Images/Icon/python.png';
import PhpIcon from '../Images/Icon/php.png';

const techStack = {
  frontend: [
    { name: 'React', icon: ReactIcon },
    { name: 'Angular', icon: AngularIcon },
    { name: 'Vue.js', icon: VueIcon },
    { name: 'Flutter', icon: FlutterIcon },
    { name: 'Ember.JS', icon: EmberIcon },
    { name: 'Bootstrap', icon: BootstrapIcon },
  ],
  backend: [
    { name: 'Node.js', icon: NodeIcon },
    { name: 'Express.js', icon: ExpressIcon },
    { name: 'GoLang', icon: GoIcon },
    { name: 'Java', icon: JavaIcon },
    { name: 'Python', icon: PythonIcon },
    { name: 'PHP', icon: PhpIcon },
  ],
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.3 },
  },
};

const itemVariantsLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0 },
};

const itemVariantsRight = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0 },
};

const itemVariantsMobile = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const TechStack = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <motion.div
      className="techstack-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.h2
        className="techstack-heading"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Hire Our Tech Experts
      </motion.h2>

      <motion.p
        className="techstack-subheading"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        Our seasoned developers have expertise with the following tech stacks:
      </motion.p>

      <div className="row">
        {/* Frontend */}
        <div className="col-md-6 mb-4">
          <h4 className="fw-bold mb-3">Front-End Technologies</h4>
          <motion.div className="row g-3" variants={containerVariants}>
            {techStack.frontend.map((tech, idx) => (
              <motion.div
                key={idx}
                className="col-12 col-sm-6"
                variants={isMobile ? itemVariantsMobile : itemVariantsLeft}
              >
                <motion.div
                  className="techstack-card"
                  whileHover={tech.name !== 'Express.js' ? { scale: 1.05 } : {}}
                >
                  <img
                    src={tech.icon}
                    alt={tech.name}
                    className="techstack-icon"
                    role="img"
                  />
                  <span className="techstack-text">{tech.name}</span>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Backend */}
        <div className="col-md-6 mb-4">
          <h4 className="fw-bold mb-3">Back-End Technologies</h4>
          <motion.div className="row g-3" variants={containerVariants}>
            {techStack.backend.map((tech, idx) => (
              <motion.div
                key={idx}
                className="col-12 col-sm-6"
                variants={isMobile ? itemVariantsMobile : itemVariantsRight}
              >
                <motion.div
                  className="techstack-card"
                  whileHover={tech.name !== 'Express.js' ? { scale: 1.05 } : {}}
                >
                  <img
                    src={tech.icon}
                    alt={tech.name}
                    className="techstack-icon"
                    role="img"
                  />
                  <span className="techstack-text">{tech.name}</span>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default TechStack;
